import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	note: string;
	value: string;
};

export const InspirationStageRow: FC<Props> = ({ label, note, value }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			gap={theme.spacingTokens.sm}
		>
			<Stack minWidth={0}>
				<Typography variant="body2">{label}</Typography>
				<Typography variant="caption" color={theme.palette.grey[500]}>
					{note}
				</Typography>
			</Stack>
			<Typography variant="bodyMedium" flexShrink={0} tabular>
				{value}
			</Typography>
		</Stack>
	);
};
